/**
 * The few colours of the `Brand Onboarding v2` mock-up the theme has no token
 * for. Everything else on these pages reads `@fluenceur/theme` tokens.
 */
export const ONBOARDING_PALETTE = {
  /** Tile behind the brand initial on the brand card. */
  initialTile: '#E0D2BE',
  /** Track of the progress bars. */
  progressTrack: '#E6E2D8',
  /** Card not reached yet: translucent white over the panel colour. */
  upcomingCard: 'rgba(255, 255, 255, 0.4)',
  upcomingCardBorder: 'rgba(26, 26, 26, 0.22)',
  cardsTray: 'rgba(255, 255, 255, 0.3)',
  cardsTrayBorder: 'rgba(255, 255, 255, 0.6)',
} as const;
